<template>
  <div id="Marketing">
    <Header :white="true" />
    <div class="mkt-body gradientBK">
      <div class="header-title">
        <div class="cont">
          <p class="titulo">Design & Branding</p>
          <p class="descrp">
            "Todo lo que puedas imaginar es real" -Picasso
          </p>
          <a href="#scrolled">
            <ScrollBehind />
          </a>
        </div>
        <div class="items-cont">
          <img src="../assets/services/s2/img1.png" alt="img" class="im1" />
          <img src="../assets/services/s2/img2.png" alt="img" class="im2" />
          <img src="../assets/services/s2/img3.png" alt="img" class="im3" />
          <img src="../assets/services/s2/img4.png" alt="img" class="im4" />
          <img src="../assets/services/s2/img5.png" alt="img" class="im5" />
        </div>
      </div>
      <div class="sec-1">
        <div class="sec-1-cont">
          <div
            class="s1-col"
            data-aos="fade-zoom-in"
            data-aos-easing="ease-in-back"
            data-aos-duration="1500"
          >
            <div class="head-col" id="scrolled">
              <p class="mbottom">
                Crear es el trabajo que nos apasiona: conocer tu 
                marca, buscar conceptos, escoger tipografías, 
                encontrar colores y texturas.
              </p>
              <p>
                Agarrar la cámara e inmortalizar esa imagen o video 
                que estuvo dando vueltas y vueltas en nuestra cabeza. 
                Abrir los programas de edición, uniendo todo y 
                dándole vida a lo que tú tanto estabas buscando.
              </p>
              <p class="quote-blue">
                <b>Las ideas motivan. Lo real acciona.</b>
              </p>
            </div>

            <div class="three-items">
              <div class="point-cont">
                <div class="point-image-cont uno"
                data-aos="fade-zoom-in"
                data-aos-easing="ease-in-back"
                data-aos-duration="1500">
                  <div class="points">
                <hr class="mo hrr">
                    <p class="titulo">Branding</p>
                    <p class="texto">
                      Construimos la identidad de tu marca teniendo en 
                      cuenta sus 3 principales pilares: propósito, 
                      valores e historia.<br><br>
                       Nuestro trabajo de branding 
                      se basa en diseñar la imagen visual y formar la 
                      línea de comunicación a utilizar para empatizar 
                      con tu mercado.  
                    </p>
                  </div>  
                <img src="../assets/des1.jpg" alt="img" class="devimg-5">
               
                </div>

                <div class="point-image-cont due"
                data-aos="fade-zoom-in"
                data-aos-easing="ease-in-back"
                data-aos-duration="1500">            
                  <img src="../assets/des2.jpg" alt="img" class="devimg-3">
                  <div class="points">
                <hr class="mo hrr">
                    <p class="titulo">Naming</p>
                    <p class="texto">
                      Nuestros proyectos de Naming siempre empiezan 
                      narrando una historia, como las que nos contaban 
                      de pequeños antes de dormir.<br><br>Ya sea si fue 
                      cierta, o la inventamos completamente, esta ayuda 
                      entender qué es y cómo surgió el producto o 
                      servicio que ofreces.
                    <br><br>
                      ¿Cómo se llaman estas historias? Bueno, 
                      exactamente de esta pregunta construimos nombres 
                      memorables y creativos.
                    </p>
                  </div>
                </div>

              <!--  <div class="point-image-cont tre"
                data-aos="fade-zoom-in"
                data-aos-easing="ease-in-back"
                data-aos-duration="1500">
                  <div class="points">
                    <p class="titulo">Páginas de destino</p>
                    <p class="texto">
                      Para mejorar los resultados y el control de tus campañas de Meta
                      y Google Ads, necesitas una página de aterrizaje. Se trata de un
                      desarrollo web sencillo, dirigido a generar una acción inmediata
                      de tu cliente objetivo. Por ejemplo: Visitar tu página, realizar
                      una suscripción o una compra en línea.
                    </p>
                  </div>
                <img src="../assets/des3.jpg" alt="img" class="devimg-4">
                </div>-->

                <div class="point-image-cont quattro"
                data-aos="fade-zoom-in"
                data-aos-easing="ease-in-back"
                data-aos-duration="1500">
                <img src="../assets/des3.jpg" alt="img" class="devimg-5">
                  <div class="points">
                <hr class="mo hrr">
                    <p class="titulo">Social Media </p>
                    <p class="texto">
                      Hacemos contenido por medio de campañas de 
                      marketing creativas para las principales redes 
                      sociales. Nuestro diseño es atractivo y en 
                      tendencia para conectar con las personas. 
                    </p>
                  </div>
                </div>

             <!--   <div class="point-image-cont cincue"
                data-aos="fade-zoom-in"
                data-aos-easing="ease-in-back"
                data-aos-duration="1500">
                  <div class="points">
                    <p class="titulo">Diseño Editorial </p>
                    <p class="texto">
                      Creamos conceptos creativos, diseños e 
                      ilustraciones para proyectos editoriales como 
                      libros, revistas y catálogos digitales y/o 
                      impresos. 
                    </p>
                  </div>
                  <img src="../assets/des2.jpg" alt="img" class="devimg-3">
                </div>
-->
              </div>
            </div>
          </div>

          <div class="ddm-sec"
                data-aos="fade-zoom-in"
                data-aos-easing="ease-in-back"
                data-aos-duration="1500">
            <p class="pc">¿No encuentras lo que necesitas?</p>
            <p class="pc"> No dudes en <a href="">hablarnos.</a></p>
            <p class="mo">¿No encuentras lo <br class="mo"> que necesitas? No dudes <br class="mo"> en <a href="">hablarnos.</a></p>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>
<script>
import Header from "../components/on-site/Header";
import Footer from "../components/on-site/Footer";
import ScrollBehind from "../components/on-site/ScrollBehind";
export default {
  components: {
    Header,
    Footer,
    ScrollBehind,
  },
  methods: {
    changeBackgroundPartners(event) {
      /***logoLegra */
      let media768 = window.matchMedia("(max-width: 768px)");
      let min768 = window.matchMedia("(min-width: 768px)");
      let divcont = document.getElementsByClassName("gradientBK")[0];
      let divcont1 = document.getElementsByClassName("logoLegra")[0];
      let number = event.target.documentElement.scrollTop;
      let offset = number * 0.09615384615384615;
      if (media768.matches) {
        if (offset <= 45) {
          divcont.style.backgroundColor = "#EF67C2";
          divcont1.style.filter = "brigthness(2)";
        }
        if (offset >= 45) {
          divcont.style.backgroundColor = "#FFFFFF";
          divcont1.style.filter = "brigthness(1)";
        }
      } else if (min768.matches) {
        /**#e4e4f9 */
        if (offset <= 57) {
          divcont.style.backgroundColor = "#EF67C2";
          divcont1.style.filter = "brigthness(2)";
        }
        if (offset >= 57) {
          divcont.style.backgroundColor = "#FFFFFF";
          divcont1.style.filter = "brigthness(1)";
        }
      }
    },
  },
  mounted() {
    window.addEventListener("scroll", this.changeBackgroundPartners);
  },
  watch: {
        $route: {
            immediate: true,
            handler(to, from) {
                document.title = to.meta.title || 'Design & Branding - Legrafica';
            }
        },
  }
};
</script>
<style scoped>
.pc{
  display: block;
}
.mo{
  display: none;
}
.im1 {
    position: absolute;
    top: 6.615vw;
    left: 36.823vw;
    width: 28.177vw;
    height: auto;
}
.im2 {
    position: absolute;
    top: 13.333vw;
    left: 31.927vw;
    width: 5.781vw;
    height: auto;
}
.im3 {
    position: absolute;
    top: 29.531vw;
    left: 66.250vw;
    width: 9.219vw;
    height: auto;
}
.im4 {
    position: absolute;
    top: 31.146vw;
    left: 25.104vw;
    width: 9.479vw;
    height: auto;
}
.im5 {
    position: absolute;
    top: -1.042vw;
    left: 63.594vw;
    width: 16.094vw;
    height: auto;
}
.im6 {
    position: absolute;
    top: 31.563vw;
    left: 75.781vw;
    width: 2.552vw;
    height: auto;
}
.im7 {
    position: absolute;
    top: 28.698vw;
    left: 24.740vw;
    width: 3.906vw;
    height: auto;
}
.im8 {
    position: absolute;
    top: 27.448vw;
    left: 82.188vw;
    width: 1.563vw;
    height: auto;

}
.mkt-body {
  background-color: #EF67C2;
}
.header-title .cont {
  /*padding: 20.26vw 0;*/
  /*margin: 0 auto;*/
  /*width: 63.958vw;*/
  position: absolute;
  padding: 20.26vw 0 20.26vw 16.823vw;
  z-index: 40;
  width: fit-content;
  margin: 0 ;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.header-title .titulo {
  font-family: "Gramatika-Medium";
  font-weight: 400;
  font-size: 7.813vw;
  line-height: 121.3%;
  /*color: #ffb6ea;*/
  color: white;
  text-align: center;
  margin: 0 0 3.906vw;
}
.header-title .descrp {
  font-family: "Gramatika-Medium";
  font-weight: 400;
  font-size: 1.146vw;
  line-height: 147%;
  text-align: center;
  color: #ffffff;
  margin: 0;
}
.s1-col {
  width: 100%;
}
.head-col {
  width: 51.667vw;
  margin: 12.708vw auto 12.552vw;
}
.head-col .mbottom {
  margin: 0 0 2.083vw;
}
.head-col p {
  font-family: "IBM Plex Mono";
  font-style: normal;
  font-weight: 400;
  font-size: 0.833vw;
  line-height: 179.8%;
  color: #000000;
  margin: 0;
  text-align: center;
}
.head-col p.quote-blue {
    font-family: 'Gramatika-Medium';
    font-style: normal;
    font-weight: 400;
    font-size: 1.354vw;
    line-height: 150.8%;
    text-align: center;
    color: #B2ACFC;
    margin-top: 7.396vw;
}
.three-items {
    display: flex;
    /*justify-content: space-between;*/
}
.point-cont {
  margin-top: 8.490vw;
    margin-left: 10.104vw;
    width: 70.781vw;
}
.point-image-cont {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 19.635vw;
}
.point-image-cont.due img {
    margin-left: 6.198vw;
}
.point-image-cont.due .points {
    margin-right: 4.896vw;
}
.point-image-cont.tre  .points{
    margin-left: 7.500vw;
}
/*.point-image-cont.cincue{
    margin-bottom: 0;
}*/
.col-img-2 {
    margin-left: 9.01vw;
}
.sec-1 {
  position: relative;
  padding-top: 52.292vw;
}
.sec-1-cont {
 /* width: 82.448vw;*/
  width: 100%;
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: 18.49vw;
  flex-direction: column;
}
.points {
  width: 21.563vw;
  padding-left: 2.604vw;
  /*padding-bottom: 6.771vw;*/
  background-image: url("../assets/linea-1.svg");
  background-size: 1.563vw;
  background-repeat: no-repeat;
  position: relative;
  left: -2.604vw;
  margin: auto 0;
}
.points .titulo {
  font-family: "IBM Plex Mono";
  font-style: normal;
  font-weight: 700;
  font-size: 0.833vw;
  line-height: 179.8%;
  color: #ef67c2;
  margin: 0;
}
.points .texto {
  font-family: "IBM Plex Mono";
  font-style: normal;
  font-weight: 400;
  font-size: 0.833vw;
  line-height: 179.8%;
  color: #000000;
  margin: 0;
}
.s1-col-2 {
  width: 38.542vw;
}
.row-1 {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}
.s1-col-2 .item-1 {
  width: 14.01vw;
  height: auto;
}
.s1-col-2 .item-2 {
  width: 21.302vw;
  height: auto;
  position: relative;
  top: 1.302vw;
}
.row-2 {
  display: flex;
  justify-content: center;
  margin-top: 5.521vw;
}
.s1-col-2 .item-3 {
  width: 28.385vw;
  height: auto;
}
.nona {
  display: none;
}

.sec-1 {
    display: flex;
    justify-content: space-between;
}
.col-img-1, .col-img-2 {
    display: flex;
    flex-direction: column;
    width: auto;
}
.col-img-1.pc, .col-img-2.pc {
    display: flex;
}
.col-img-1.mo, .col-img-2.mo {
    display: none;
}
.devimg-1 {
    width: 21.302vw;
    height: auto;
}
.devimg-2 {
    width: 16.51vw;
    height: auto;
    margin-top: 11.667vw;
    margin-left: 7.656vw;
}
.devimg-3 {
    width: 22.656vw;
    height: auto;
    margin-left: 2.396vw;
    margin-bottom:0;
}
.devimg-4 {
    width: 17.5vw;
    height: auto;
    margin-left: 5.833vw;
    margin-bottom: 0;
}
.devimg-5 {
    width: 25.052vw;
    height: auto;
}
@media (max-width: 768px) {
  
.pc{
  display: none;
}
.mo{
  display: block;
}
  .sec-1  {
    position: relative;
    padding-top: 224.396vw;
}
.im1 {
    top: 27.295vw;
    left: 0;
    width: 100vw;
}
.im2 {
    position: absolute;
    top: 23.913vw;
    left: 85.024vw;
    width: 4.106vw;
    height: auto;
}
.im3 {
    position: absolute;
    top: 27.295vw;
    left: 17.633vw;
    width: 3.14vw;
    height: auto;
}
.im4 {
position: absolute;
    top: 135.961vw;
    left: -11.836vw;
    width: 49.961vw;
    height: auto;
}
.im5 {
    top: 21.295vw;
    left: 59.42vw;
    width: 44.928vw;
}
.im6 {
    position: absolute;
    top: 58.213vw;
    left: 89.614vw;
    width: 5.556vw;
    height: auto;
}
.im7 {
    position: absolute;
    top: 62.802vw;
    left: 2.657vw;
    width: 7.005vw;
    height: auto;
}
.im8{
  display: none;
}
  .nona {
    display: block;
  }
  .header-title .cont {
    padding: 57.971vw  0 57.971vw 0;
  }
  .header-title .titulo {
    font-size: 13.285vw;
  }
  .header-title .descrp {
    font-size: 3.623vw;
    width: 68.357vw;
  }
  .sec-1-cont {
    width: 100%;
    padding-bottom: 43.72vw;
    flex-direction: column;
  }
  .point-cont {
    margin-top: 6.28vw;
    margin-left: 12.319vw;
    position: absolute;
    width: 73.913vw;
}
.point-image-cont.due img{
  margin: 0;
}
.point-image-cont.due .points{
  margin: auto;
}
.hrr {
    width: 7.971vw;
    border: 1px solid #EF67C2;
    margin: 0 0 11.353vw;
    position: relative;
    right: 8vw;
}
  .s1-col {
    width: 100%;
  }
  .head-col p {
    font-size: 2.899vw;
    text-align: left;
  }
  .head-col .mbottom {
    margin: 0 0 7.246vw;
  }
  .head-col {
    margin-bottom: 25.845vw;
    width: 69.565vw;
  }
  .head-col p.quote-blue {
    font-size: 4.348vw;
    width: 41.86vw;
    margin: 22.947vw auto 0;
}
.point-image-cont {
    margin-bottom: 31.401vw;
    flex-direction: column;
}
.point-image-cont.due,.point-image-cont.quattro  {
    flex-direction: column-reverse;
}
  .points .titulo {
    font-size: 2.899vw;
  }
  .points .texto {
    font-size: 2.899vw;
  }
  .points {
   /* padding-left: 12.077vw;*/
    padding-left: 0;
    padding-bottom: 31.401vw;
    background-size: 7.246vw;
    left: 0;
    width: 67.874vw;
    margin: auto;
    background-image: none;
  }
  .three-items{
    width: 100%;
    /*height: 825vw;*/ 
    height: 645vw;
    justify-content: space-between;
  }
  .devimg-4,.devimg-5 ,.devimg-3 {
    width: 73.913vw;
    }
  .s1-col-2 {
    width: 100%;
  }
  .s1-col-2 .item-1 {
    width: 33.575vw;
  }
  .s1-col-2 .item-2 {
    width: 42.271vw;
    top: 4.302vw;
  }
  .s1-col-2 .item-3 {
    width: 68.116vw;
  }
  .row-2 {
    margin-top: 11.521vw;
  }
  .col-img-1.pc, .col-img-2.pc {
      display: none;
  }
  .col-img-1.mo, .col-img-2.mo {
      display: flex;
  }
  .ddm-sec{
    width: auto;
  }
}
</style>